//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import EvaIcon from '../../../svg-components/EvaIcon'
import { Spa2Route } from '@/ExternalRoutes'

export default {
    components: {
        EvaIcon,
    },
    data() {
        return {
            unreadMessageCount: 0,
            Spa2Route,
        }
    },
    mounted() {
        // disable temporarily inbox counter for BR2
        // this.getUnreadMessagesCount()
    },
    methods: {
        getUnreadMessagesCount: async function() {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
            const response = await axios.get('/ekko/unread-count')
            this.unreadMessageCount = response.data.count
        },
        isActive: function() {
            return window.location.pathname.includes('inbox')
        },
    },
}
